import React, { useState, useCallback, useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { ClarityEventSetup, getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { StepContainer } from '../step-container/step-container';
// import { getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';
import { GoalCreationWizardContext } from '../../goal-creation-wizard-context';
import { getClarityEventInfo,
  postClarityEventInfo,
  getErrorMessage,
  saveGoal,
  processPayload,
  updateGoalObjectForClaritySetup } from '../../conversion-goals-repository';
import { WIZARD_ACTIONS } from '../../goal-creation-wizard-reducer';

const containerStyles = () => ({
  ...getStepStyles(),
});

const UnstyledTagSetupInstallEventTagWithClarity = (props) => {
  const wizardContext = useContext(GoalCreationWizardContext);
  const i18n = useContext(I18nContext);
  const [shouldBlockerLoading, setShouldBlockerLoading] = useState(true);
  const [clarityEventObjectExists, setClarityEventObjectExists] = useState(false);
  const { isUpdateRequired, goal } = useMemo(() => updateGoalObjectForClaritySetup(wizardContext.goalContext), [wizardContext.goalContext]);

  const saveGoalParametersAndPostClarity = useCallback((cid, aid, Id, Token, clarityEventInfo) => {
    const p$processedGoal = isUpdateRequired ? saveGoal(processPayload(goal, wizardContext.permissions), wizardContext) : Promise.resolve();
    return p$processedGoal.then(() => postClarityEventInfo(cid, aid, Id, Token, clarityEventInfo));
  }, [goal, isUpdateRequired, wizardContext]);

  const clarityTagSetupRepository = useMemo(() => ({
    getClarityEventInfo,
    postClarityEventInfo: saveGoalParametersAndPostClarity,
    getErrorMessage,
    saveGoal,
    processPayload,
  }), [saveGoalParametersAndPostClarity]);

  const handleSkipForNow = useCallback(() => {
    // logActivity.trace(`[ClarityEventSetup] Skip for now clicked for tag id: ${tagId}`);
    wizardContext.goToNext();
  }, [wizardContext]);

  const footerConfig = useMemo(() => ({
    buttons: [{
      type: 'Secondary',
      onClick: wizardContext.goBack,
      isEnabled: true,
      text: i18n.getString(_TL_(('Back'))),
    },
    {
      type: 'Primary',
      onClick: wizardContext.goToNext,
      isEnabled: clarityEventObjectExists && !shouldBlockerLoading,
      text: i18n.getString(_TL_(('Next'))),
    },
    {
      type: 'Cancel',
      onClick: wizardContext.cancel,
      isEnabled: !shouldBlockerLoading,
      text: i18n.getString(_TL_(('Cancel'))),
    },
    ...(!clarityEventObjectExists ?
      [{
        type: 'Link',
        onClick: handleSkipForNow,
        isEnabled: !shouldBlockerLoading,
        text: i18n.getString(_TL_(('I\'ll do this later, skip for now'))),
      }] : [])],
  }), [wizardContext.goBack, wizardContext.goToNext, wizardContext.cancel, i18n, clarityEventObjectExists, shouldBlockerLoading, handleSkipForNow]);

  const goToManualSetupPage = useCallback((payload) => {
    wizardContext.dispatch(Object.assign({
      type: WIZARD_ACTIONS.EVENT_TAG_SETUP,
      eventTagSetupMethod: 'manualSetup',
    }, payload ? { data: payload } : {}));
  }, [wizardContext]);

  const stepTitle = wizardContext.goalContext.Type === 'EventGoal' ? i18n.getString(_TL_('Add Event tag')) : i18n.getString(_TL_('Add URL tag'));
  return (
    <StepContainer
      subContainer
      step="tag-clarity-setup-selection"
      footerConfig={footerConfig}
      title={stepTitle}
    >
      <div className={props.classes.contentBlock}>
        <UiBlocker
          blocking={shouldBlockerLoading}
          loadingText={i18n.getString(_TL_('Loading...'))}
        >
          <ClarityEventSetup
            wizardContext={wizardContext}
            setShouldBlockerLoading={setShouldBlockerLoading}
            setClarityEventObjectExists={setClarityEventObjectExists}
            clarityTagSetupRepository={clarityTagSetupRepository}
            goToManualSetupPage={goToManualSetupPage}
            serverContext={props.serverContext}
            goalAction={goal.Action}
            permissions={wizardContext.permissions}
          />
        </UiBlocker>
      </div>
    </StepContainer>
  );
};

export const TagSetupInstallEventTagWithClarity = withDefaultStyles(withServerContext(UnstyledTagSetupInstallEventTagWithClarity), containerStyles);
